import { Component } from "@angular/core";
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterLinkActive,
} from "@angular/router";

@Component({
  selector: "app-header",
  imports: [RouterLink],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.css",
})
export class HeaderComponent {
  activeLink: { [K in 'play' | 'howitworks' | 'feedback']: boolean } = { play: true, howitworks: false, feedback: false };
  constructor(private route: ActivatedRoute) {}
  setActiveLink(object: any) {
    for (const key in this.activeLink) {
      this.activeLink[key as 'play' | 'howitworks' | 'feedback'] = key === object.target.hash.substring(1);
    }
  }
}
